export default {
    title: 'Tuyển sinh Năm học 2024-2025',
    api_url: process.env.REACT_APP_API_BASE_URL,
    home_url: process.env.REACT_APP_PORTAL_URL,
    register_url: process.env.REACT_APP_REGISTER_URL,
    sub_system_id: 1,
    versionDataGridStorageKey: process.env.DATA_GRID_STOREGE_VERSION?.toString() || "",
};
